// Legal document registry — the markdown drafts in src/lib/data are the
// single source of truth, shared by the footer LegalSheet and the
// full-screen legal pages.

import privacyPolicyMd from '@/lib/data/privacy_policy.md?raw';
import termsOfServiceMd from '@/lib/data/terms_of_service.md?raw';

export const LEGAL_DOCS = {
  privacy: {
    title: 'Privacy Policy',
    content: privacyPolicyMd,
    path: '/privacy-policy',
  },
  terms: {
    title: 'Terms of Service',
    content: termsOfServiceMd,
    path: '/terms-of-service',
  },
} as const;

export type LegalDocKey = keyof typeof LEGAL_DOCS;
